import { observer } from 'mobx-react';
import { avatarFrom } from '../../../../../../Avatar';
import { findLink } from '../../../../../../LinkyLinky';
import { NotTranslated } from '../../../../../../Translations';
import PersonPhoto from '../../../../../PersonPhoto';
import { ConfirmingDeactivate } from '../../Store/InvitationStore/Types';

interface Props {
  state: ConfirmingDeactivate;
}

function ParticipantInfo({ state }: Props) {
  return (
    <div className="flex py-4 gap-2 items-center">
      <div className="flex" data-test-person={true}>
        <div
          className="relative h-10 w-10 min-w-[100%] rounded-full bg-[#187A90]"
          data-test-person-avatar={true}
        >
          <PersonPhoto
            avatar={avatarFrom(
              findLink('avatar', state.resource.links),
              state.resource.payload.initials,
            )}
          />
        </div>
      </div>
      <span>
        <div>
          <NotTranslated text={state.resource.payload.name} />
        </div>
        <div className="text-sm">
          <NotTranslated text={state.resource.payload.email} />
        </div>
      </span>
    </div>
  );
}

export default observer(ParticipantInfo);
